import A11yDialog from 'a11y-dialog';

export default function blocks() {
  const $ = jQuery;
  jQuery('.accordion-panel__content').each( function(i, item) { jQuery( item ).slideUp(); });
  jQuery('.accordion-panel__header').click( function() {
    jQuery( this ).parent().toggleClass( 'open' );
    jQuery( this ).next().slideToggle( 'fast' );
  });

  $( '.in-the-wild-modal li.add-on-product__variation-item' ).on( 'click', function( e ) {
    let variationId = $( this ).attr( 'data-variation-id' );
    let $modalParent = $( this ).parents( '.modal-content__product' );
    let dataProducts = JSON.parse( $modalParent.find( '.add-to-cart__button' ).attr( 'data-products' ) );
    dataProducts[0]  = variationId;
    $modalParent.find( '[data-action="add-to-cart"]' ).attr( 'data-products', JSON.stringify( dataProducts ) );
  });

  /* In the wild */
  $( '.in-the-wild-modal' ).each( function( e ) {

    const el = $( this )[0];
    const dialog = new A11yDialog( el );

    dialog.on( 'show', function ( dialogEl, event ) {
      // disable scroll on body
      $( 'body' ).css( 'overflow', 'hidden' );
      const fullImageSrc = dialogEl.getAttribute( 'data-full-image' );
      $(dialogEl).find('img').attr('src', fullImageSrc);
    });

    dialog.on('hide', function (dialogEl, event) {
      // enable body scroll
      $('body').css('overflow', 'visible');

      $( '.in-the-wild-modal' ).each( function( e ) {
        $(this).attr( 'aria-hidden', 'true' );
      });
      // remove focus from the link
      $('.instagram-feed  a').blur();

    });

    $('.add-to-cart__button ').on( 'click', function( e ){
      dialog.hide();
    });
  });
}
